import { render, staticRenderFns } from "./EditWebhook.vue?vue&type=template&id=2423091f"
import script from "./EditWebhook.vue?vue&type=script&lang=js"
export * from "./EditWebhook.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports